import React, { useEffect, useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { DivStyled, ContainerStyled } from './styled';
import GoogleMaps from './components/GoogleMaps';
import { getGarageById } from '../GarageEditPage/actions';
import Menu from '../components/Menu';
import GaragePageHeader from '../components/GaragePageHeader';
import { getGarageCoverage, createGarageCoverage, getGarageZoneShapes } from './actions';
import Loading from '$app/shared/components/Loading';

function GarageCoveragePage({ history, match }) {
  const garageId = match.params.garageId;
  const [garage, setGarage] = useState(null);
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [coverage, setCoverage] = useState('');
  const [otherGaragesCoverage, setotherGaragesCoverage] = useState([]);

  useEffect(() => {
    getGarageById(garageId).then((garage) => {
      const { latitude, longitude } = garage;
      setGarage(garage);
      setLat(latitude);
      setLng(longitude);
    });

    getGarageCoverage(garageId).then((garageCoverage) => setCoverage(garageCoverage));
    // filter out the garage being edited & innactive garages
    getGarageZoneShapes().then((data) =>
      setotherGaragesCoverage(
        data.filter(({ ownerId, garageStatus }) => ownerId !== garageId && garageStatus === 'ACTIVE')
      )
    );
  }, [garageId]);

  const updateCoverage = useCallback((data) => {
    createGarageCoverage(data);
    setCoverage(data);
  }, []);

  const cancelCoverageEdits = useCallback(() => setCoverage({ ...coverage }), [coverage]);

  if (!garage) return <Loading />;
  const displayMap = lat && lng;

  return (
    <ContainerStyled>
      <GaragePageHeader history={history} name={garage?.businessName} />
      <Menu selectedItem="coverage" garageId={garageId} history={history} />
      <DivStyled>
        {displayMap && (
          <GoogleMaps
            updateCoverage={updateCoverage}
            cancelCoverageEdits={cancelCoverageEdits}
            otherGaragesCoverage={otherGaragesCoverage}
            garage={{ lat, lng, garageId, coverage, segment: garage.segment }}
          />
        )}
      </DivStyled>
    </ContainerStyled>
  );
}

export default withRouter(GarageCoveragePage);
